var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-screen"},[_c('div',{staticClass:"flex flex-col items-center justify-center h-screen"},[_c('div',{staticClass:"lds-ring"},[_c('div'),_c('div'),_c('div'),_c('div')]),_c('div',{staticClass:"mt-3"},[_vm._v("กรุณารอซักครู่...")])])])
}]

export { render, staticRenderFns }